export default __webpack_public_path__ + "static/media/three_rules.124471c0.jpg";